import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const Wrapper = styled.div`
  display: block;
  flex-wrap: wrap;
  align-content: space-between;

  ${breakpoint.tablet`
    display:flex;
  `};
`;

export const Col = styled.div`
  flex: 1;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.large};

  ${breakpoint.tablet`
    min-width: calc(50% - ${({ theme }) => theme.spacing.large});
    width: calc(50% - ${({ theme }) => theme.spacing.large});
  `};

  ${breakpoint.desktop`
    min-width: calc(33% - ${({ theme }) => theme.spacing.large});
    width: calc(33% - ${({ theme }) => theme.spacing.large});
  `};

  &:nth-child(even),
  &:nth-child(1) {
    margin-right: ${({ theme }) => theme.spacing.large};
  }
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontsize.h3};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
